import { Grid, Tab, Tabs } from '@mui/material';
import { Link, Route, Switch } from 'react-router-dom';
import { MDBox } from '../../Component/Common/Components/MDBox';
import { MDTypography } from '../../Component/Common/Components/MDTypography';
import { useRouteMatch } from '../../Helpers/RouteMatcher';
import { VerificationAgencyClientsPage } from './Clients/VerificationAgencyClientsPage';
import { VerificationAgencyClientApplicationPage } from "./Applications/VerificationAgencyClientApplicationsPage";
import { CertificateRegistryPage } from './CertificateRegistry/CertificateRegistry';
import config from '../../config';
import { GeneratedCertificateRegistryPage } from './GeneratedCertificatesRegistry/GeneratedGeneratedCertificateRegistry';
import { DocumentRepoBasePage } from '../EmploymentEquity/DocumentRepo/DocumentRepoBasePage';
import { DocumentRepoSectionModuleTypes } from '../../Component/Model/Enum/BEE123Enums';
import { AutomatedNotificationsPage } from './Notifications/AutomatedNotificationsPage';

export const ClientManagementBase = () => {
  const routes = [
    "/clientManagement/clients",
    "/clientManagement/applications",
    "/clientManagement/documentRepository",
    "/clientManagement/certificateRegistry",
    "/clientManagement/notifications",
  ]
  
  const routeMatch = useRouteMatch(routes);
  const currentTab = routeMatch?.path;

  return (
    <>
      <MDBox style={{ padding: "10px" }}>
        <MDTypography variant='h4' fontWeight='bold' style={{ paddingBottom: "15px" }}>
          Client Relationship Management
        </MDTypography>
      </MDBox>
      <Grid container>
        <Grid item xs={12}>
          <Tabs value={currentTab} aria-label="Tabs" centered>
            <Tab label="Clients" value={routes[0]} to={routes[0]} component={Link} />
            <Tab label="Applications" value={routes[1]} to={routes[1]} component={Link} />
            <Tab label="Document Repository" value={routes[2]} to={routes[2]} component={Link} />
            <Tab label="Certificate Registry" value={routes[3]} to={routes[3]} component={Link} />
            <Tab label="Notifications" value={routes[4]} to={routes[4]} component={Link} />
          </Tabs>
        </Grid>
        <Grid item xs={12} mt={1}>
          <Switch>
            <Route path={routes[0]}>
              <VerificationAgencyClientsPage />
            </Route>
            <Route path={routes[1]}>
              <VerificationAgencyClientApplicationPage showAll={true}/>
            </Route>
            <Route path={routes[2]}>
              <DocumentRepoBasePage documentRepoSectionModuleType={DocumentRepoSectionModuleTypes.Verificaion_Agency}/>
            </Route>
            <Route path={routes[3]}>
              {config.enable_certificate_registry === "true" ?
                <CertificateRegistryPage />
                :
                <GeneratedCertificateRegistryPage />
              }
            </Route>
            <Route path={routes[4]}>
              <AutomatedNotificationsPage />
            </Route>
          </Switch>
        </Grid>
      </Grid>
    </>);
}
